module.exports = __webpack_public_path__ + "img/286.3d0ee36a.jpg";